import { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setLegalEntity } from '../../../../../../../store/slices/dashboardSlice/action';
import { LegalEntity } from '../../../../../types/dashboardInformation';

type ContractorOption = {
    title: string;
    value: string;
    isDimmed: boolean;
};

export const useContractorRow = () => {
    const dispatch = useDispatch();
    const { information, is_customer, can_show_financial_info } = useSelector(
        // @ts-ignore
        (store) => store.dashboardReducer
    );
    const [optionsList, setOptionsList] = useState<ContractorOption[]>([]);
    const [selected, setSelected] = useState<ContractorOption>({
        title: '',
        value: '',
        isDimmed: false,
    });

    useEffect(() => {
        const updatedOptionsList = information.legal_entities.reduce(
            (acc: ContractorOption[], company: LegalEntity) => {
                const obj = {
                    title: company.name,
                    value: company.guid,
                    isDimmed: company.locked_by_tariff,
                };
                if (company.selected) {
                    setSelected(obj);
                }
                acc.push(obj);
                return acc;
            },
            []
        );
        setOptionsList(updatedOptionsList);
    }, [information.legal_entities]);

    const onSelected = useCallback(
        async (value: string) => {
            const selectedOption = optionsList.find((option) => option.value === value);
            if (selectedOption) {
                const result = await dispatch(setLegalEntity(selectedOption.value));

                if (setLegalEntity.fulfilled.match(result)) {
                    setSelected(selectedOption);
                }
            }
        },
        [dispatch, optionsList]
    );
    return {
        optionsList,
        selected,
        onSelected,
        is_customer,
        can_show_financial_info,
    };
};
